import React from 'react';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
import { LogoCarousel } from '../ui/LogoCarousel';
export const HeroSection: React.FC = () => {
  const logos = ['https://uploadthingy.s3.us-west-1.amazonaws.com/4hsFn1bXWgpaJw4eVPXWMu/image_3.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6Vw9jxVu6Aq81G41yd5ctH/image_7.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/uo5388jZ7YguXpjvgH8wvn/image_9.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/7xrpKvQsuWnM4W1YgYiaBP/image_10.png', 'https://cdn.magicpatterns.com/uploads/mPyeph882JKwjn9RaHTaP9/Chiro_Venture_-_white_no_background_1.png', 'https://cdn.magicpatterns.com/uploads/mxhhN1AVnPTvg368rZGcTh/favicon_update-150x150_1.png'];
  return <section className="w-full bg-gradient-to-b from-dark-900 via-dark-900 to-dark-800 py-24 md:py-32 relative overflow-hidden" data-id="element-606">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 pointer-events-none" data-id="element-607" />
      <Container className="relative z-10" data-id="element-608">
        <div className="flex flex-col items-center text-center" data-id="element-609">
          <div className="mb-8 w-48 md:w-64" data-id="element-610">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2DzbdAXB8rnWSnnsNSpx4E/widelogo.png" alt="DealFlow.ai Logo" className="w-full h-auto" data-id="element-611" />
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 max-w-4xl" data-id="element-612">
            Digital Deal Sourcing for Private Equity
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-10" data-id="element-613">
            We deliver pre-qualified seller leads on autopilot—so you see{' '}
            <span className="font-bold text-white" data-id="element-614">deals first</span>,{' '}
            <span className="font-bold text-white" data-id="element-615">close faster</span>, and buy
            at <span className="font-bold text-white" data-id="element-616">better valuations</span>.
          </p>
          <Button variant="primary" size="lg" href="https://form.typeform.com/to/ePFsBam5" data-id="element-617">
            Click here to schedule a call
          </Button>
          <div className="mt-16 w-full" data-id="element-618">
            <LogoCarousel logos={logos} data-id="element-619" />
          </div>
        </div>
      </Container>
    </section>;
};